import * as BABYLON from "babylonjs";
import {
  copymesh
} from "../Tools/index.js";
import {
  meshoutline,
  meshMouseIn
} from "../Tools/mesheffect";
import config from "../config";
import _ from "lodash";
export class Product {
  constructor(objinfo) {
    this.id = objinfo.meta.id;
    this.objinfo = objinfo;
    this.name = objinfo.meta.id;
    this.type = objinfo.meta.meshType;
    this.config = config[this.type];
    let mesh = levelsShowIns.loader.cache[this.type + ".glb"].meshes[1];
    this.mesh = copymesh(mesh, this.type);
    this.mesh.material.metallic = 0
    // levelsShowIns.lignt.renderList.push(this.mesh);
    this.mesh.$objinfo = objinfo;
    this.mesh.scaling.x = config.scal;
    this.mesh.scaling.y = config.scal;
    this.mesh.scaling.z = config.scal;

    this.mesh.name = objinfo.meta.id;
    this.mesh.id = objinfo.meta.id;
    this.mesh.visibility = 1.0;
    this.mesh.$type = this.type;
    this.mesh.rotation = new BABYLON.Vector3();
    this.mesh.rotation.y = (Math.PI * objinfo.meta.rotation) / 180;
    // if (this.type == "product1") { //todo  模型格式不一样 导致后面的算法处理很麻烦  我需要沿着Z轴旋转180度  product2  后面改了一次就好了
    //   this.mesh.rotation.z = Math.PI;
    //   this.mesh.rotation.y =
    //     (Math.PI * objinfo.meta.rotation) / 180 - Math.PI / 2;
    // }
    // if( this.type == 'product2'){
    //   this.mesh.rotation.z = Math.PI  ;
    //   this.mesh.rotation.y = Math.PI * objinfo.meta.rotation / 180 -  Math.PI/2 ;
    // }
    this.mesh.position.x = objinfo.meta.x;
    this.mesh.position.z = -objinfo.meta.z;
    let pidType = _.find(levelsShowIns.projectInfo.layout, function(item) {
      return item.id == objinfo.pid;
    }).meta.meshType;
    this.setWarnColor()
    this.mesh.position.y = pidType == "水泥台" ? config.table.height : 0.1;
    // "一体1列1簇":"product1",
    // "一体2列1簇":"product2",
    // "一体箱式":"product3",
    // "一体箱式22簇":"product6",
    // "分体电池仓3簇":"product4",
    // "分体电池仓箱式":"product5",
    // "功率仓":"powerBox",
    // "电气仓":"electricalBox",
    // "风车":"wind",
    // "停车":"park",
    // "光伏":"light",
    // "电塔":"tower",
    let logs = [
      "product1",
      "product2",
      "product3",
      "product4",
      "product5",
      "product6",
      "product7",
      "powerBox",
      "electricalBox",
      "dryandwet"
    ];
    if (logs.indexOf(this.type) > -1) {
      this.addLogo(this.mesh.rotation);
    }
    let actions = [
      "product1",
      "product2",
      "product3",
      "product4",
      "product5",
      "product6",
      "product7",
      //"powerBox"
    ];

    if (actions.indexOf(this.type) > -1) {
      this.addAction(this.mesh, this.logo);
    }
    let pops = [
      "powerBox",
      "electricalBox",
      "dryandwet"
    ]
    if (pops.indexOf(this.type) > -1) {
      this.popAction(this.mesh);
    }
    levelsShowIns.eventbus.$on("meshhide", this.hide, this);
    // this.mesh.material.setColor
  }
  //设置产品告警红色
  setWarnColor() {
    let position = [];
    let alarm = levelsShowIns.projectInfo.alarm
    //告警过滤
    if (alarm.length) {
      alarm.forEach(item => {
        if (item.positions.length > 0) {
          position = [...item.positions];
        }
      });
    }
    position.forEach(item => {
      if (item.cabin == this.mesh.$objinfo.meta.name) {
        this.mesh.material.albedoColor = new BABYLON.Color3.Red()
      }
    })
  }
  addLogo(rotation) {
    let scene = levelsShowIns.scene;
    let material = new BABYLON.StandardMaterial("logomaterial", scene);
    material.emissiveColor = new BABYLON.Color3(1, 1, 1);
    material.backFaceCulling = false;
    let mesh = BABYLON.Mesh.CreatePlane(
      "logo",
      8 * this.config.logo.size,
      scene,
      true
    );
    mesh.material = material;
    let texture = new BABYLON.Texture("/static/webgl/logo.png", scene);
    mesh.rotation.y = rotation.y;
    // mesh.rotation.z =rotation.z
    texture.coordinatesMode = 7;
    texture.uScale = 1;
    texture.vScale = 1;
    mesh.material.diffuseTexture = texture;
    mesh.material.opacityTexture = texture;
    this.logo = mesh;
    this.mesh.addChild(mesh);
    mesh.position.set(...this.config.logo.poi);
  }
  hide(p) {
    if (p.id == 0) {
      try {
        this.mesh.animationCtr.stop();
        this.mesh.animationCtr.reset();
      } catch (error) {}
    }
    // console.log("Product hide");
    let isPickable = p.visibility == 1;
    if (p.id == this.objinfo.pid || p.id == this.objinfo.id) {
      this.mesh.visibility = 1;
      this.mesh.isPickable = true;
      this.logo.visibility = 1;
      this.logo.isPickable = true;
    } else {
      this.mesh.visibility = p.visibility;
      this.mesh.isPickable = isPickable;

      this.logo.visibility = p.visibility;
      this.logo.isPickable = isPickable;
    }

  }
  //弹出事件
  popAction(mesh) {
    let that = this;
    mesh.actionManager = new BABYLON.ActionManager(levelsShowIns.scene);
    mesh.actionManager.registerAction(
      new BABYLON.ExecuteCodeAction(
        BABYLON.ActionManager.OnPointerOverTrigger,
        e => {
          levelsShowIns.poplabel(that);
        }
      )
    );
    mesh.actionManager.registerAction(
      new BABYLON.ExecuteCodeAction(
        BABYLON.ActionManager.OnPointerOutTrigger,
        e => {
          levelsShowIns.poplabel();
        }
      )
    );
  }
  //驱动事件
  addAction(mesh, logo) {
    let that = this;
    mesh.actionManager = new BABYLON.ActionManager(levelsShowIns.scene);
    logo.actionManager = new BABYLON.ActionManager(levelsShowIns.scene);
    mesh.actionManager.registerAction(
      new BABYLON.ExecuteCodeAction(
        BABYLON.ActionManager.OnPointerOverTrigger,
        e => {
          meshMouseIn(mesh, true);
          levelsShowIns.poplabel(that);
        }
      )
    );
    mesh.actionManager.registerAction(
      new BABYLON.ExecuteCodeAction(
        BABYLON.ActionManager.OnPointerOutTrigger,
        e => {
          meshMouseIn(mesh, false);
          levelsShowIns.poplabel();
        }
      )
    );
    logo.actionManager.registerAction(
      new BABYLON.ExecuteCodeAction(
        BABYLON.ActionManager.OnPickTrigger,
        async e => {
          if (levelsShowIns.loader.cache[mesh.$type + "in.glb"] == 'loading' && mesh.$type.indexOf("product") > -
            1) {
            return false
          }
          if (!levelsShowIns.loader.cache[mesh.$type + "in.glb"] && mesh.$type.indexOf("product") > -1) {
            await levelsShowIns.loader.load(
              levelsShowIns.scene,
              '/static/webgl/',
              mesh.$type + "in.glb",
              mesh.$type + "in.glb"
            )
          }
          levelsShowIns.activeOut = that.id;
          levelsShowIns.eventbus.$emit("meshhide", {
            id: mesh.id,
            visibility: 0
          });
          mesh.visibility = 1.0;
          mesh.isPickable = true;
          logo.visibility = 1.0;
          logo.isPickable = true;
          await levelsShowIns.camera.cameraGoMesh(mesh);
          levelsShowIns.meshIn(mesh, logo);
          levelsShowIns.eventbus.$emit("levelchange", 2);
        }
      )
    );
    mesh.actionManager.registerAction(
      new BABYLON.ExecuteCodeAction(
        BABYLON.ActionManager.OnPickTrigger,
        async e => {
          if (levelsShowIns.loader.cache[mesh.$type + "in.glb"] == 'loading' && mesh.$type.indexOf("product") > -
            1) {
            return false
          }
          if (!levelsShowIns.loader.cache[mesh.$type + "in.glb"] && mesh.$type.indexOf("product") > -1) {
            await levelsShowIns.loader.load(
              levelsShowIns.scene,
              '/static/webgl/',
              mesh.$type + "in.glb",
              mesh.$type + "in.glb"
            )
          }
          levelsShowIns.activeOut = that.id;
          levelsShowIns.eventbus.$emit("meshhide", {
            id: mesh.id,
            visibility: 0
          });
          mesh.visibility = 1.0;
          mesh.isPickable = true;
          logo.visibility = 1.0;
          logo.isPickable = true;
          await levelsShowIns.camera.cameraGoMesh(mesh);
          //触发显示二级
          levelsShowIns.meshIn(mesh, logo);
          levelsShowIns.eventbus.$emit("levelchange", 2);
        }
      )
    );
  }
  focus() {}
  blur() {}
  show() {}
  setColor() {}
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Object/Product.js